import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\GetCompanyPaymentSyncOverviewController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/GetCompanyPaymentSyncOverviewController.php
* @route '/api/company/{company}/chift/payment-sync'
*/
const GetCompanyPaymentSyncOverviewController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCompanyPaymentSyncOverviewController.url(args, options),
    method: 'get',
})

GetCompanyPaymentSyncOverviewController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/chift/payment-sync',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\GetCompanyPaymentSyncOverviewController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/GetCompanyPaymentSyncOverviewController.php
* @route '/api/company/{company}/chift/payment-sync'
*/
GetCompanyPaymentSyncOverviewController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return GetCompanyPaymentSyncOverviewController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\GetCompanyPaymentSyncOverviewController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/GetCompanyPaymentSyncOverviewController.php
* @route '/api/company/{company}/chift/payment-sync'
*/
GetCompanyPaymentSyncOverviewController.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCompanyPaymentSyncOverviewController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\GetCompanyPaymentSyncOverviewController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/GetCompanyPaymentSyncOverviewController.php
* @route '/api/company/{company}/chift/payment-sync'
*/
GetCompanyPaymentSyncOverviewController.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCompanyPaymentSyncOverviewController.url(args, options),
    method: 'head',
})

export default GetCompanyPaymentSyncOverviewController